import { MultiselectValue, MultiselectOccurrenceValue } from "@simplyk/common";

export const getFormLabel = (choice: MultiselectValue | MultiselectOccurrenceValue, locale: string): string => {
  const castChoice = choice as MultiselectValue;
  return castChoice.labels.find((label) => label.locale === locale)?.label || castChoice.labels[0].label;
};
